import { postpro } from "../index";

export const createParameter = (data) => {
  return postpro("/parameters", data, false);
};
